export default __webpack_public_path__ + "static/media/BrainBreak cards7.bb7ec561.png";